module.exports = __webpack_public_path__ + "img/dy_code.1b8d6556.png";